import { flatten } from 'lodash';
import i18n from '@/../i18n';

export enum FeatureUsageCategory {
    UsedInCampaign = 0,
    UsedInSegment = 1,
    UsedInAutomation = 2,
    UsedInLandingPage = 3,
    UsedInForm = 4,
    UsedInCheckouts = 5,
    UsedInPaidNewsletters = 6
}

export type ErrorModel = {
    MessageID?: string;
    MessageParts: string[];
    RelatedTo?: string;
};

/**
 *  this will go through the enum and find proper names in which list or custom fields are used
 * @param errorParams params returned from the backend that contain names of features that lists or forms are used
 * @returns names of the entities matched by the FeatureUsageCategory.
 */
export const matchErrorMessagesForUsageInFeatures = (errorParams: Record<string, ErrorModel[]>): string[] => {
    const availablePrefixes = {
        [FeatureUsageCategory.UsedInCampaign]: { prefix: i18n.t('campaign') },
        [FeatureUsageCategory.UsedInSegment]: { prefix: i18n.t('segment') },
        [FeatureUsageCategory.UsedInAutomation]: { prefix: i18n.t('automation') },
        [FeatureUsageCategory.UsedInLandingPage]: { prefix: i18n.t('landingpage') },
        [FeatureUsageCategory.UsedInForm]: { prefix: i18n.t('form') },
        [FeatureUsageCategory.UsedInCheckouts]: { prefix: i18n.t('checkout') },
        [FeatureUsageCategory.UsedInPaidNewsletters]: { prefix: i18n.t('paidnewsletter')}
    };

    return Object.values(FeatureUsageCategory).reduce((acc, idx) => {
        const { prefix } = availablePrefixes[idx] || {};
        if (prefix === undefined) return acc;
        const names = flatten(errorParams?.[idx]?.map?.((el) => el.MessageParts?.map?.((name) => `${prefix}: ${name}`)));
        if (!names?.length) return acc;
        return [...acc, ...names];
    }, []);
};
